import { isArray } from "lodash";
import { IAbsenceGroup } from "src/Pages/Company/Absences/AbsenceGroups/AbsenceGroups.models";

/**
 * Function splitting absence groups retrieved from API into two collections - active and inactive.
 * Active groups preserve the API response order (managed via order configuration).
 * Inactive groups are sorted alphabetically by name.
 * @param {array} data - collection of all absence groups configured for particular company
 * @returns {array} Array of two collections of given absence groups filtered by active status.
 */
export default (data?: IAbsenceGroup[]) => {
  if (!isArray(data)) return [];

  const activeGroups = data.filter((group) => group.active);
  const inactiveGroups = data
    .filter((group) => !group.active)
    .sort((a, b) => a.name.localeCompare(b.name));

  return [activeGroups, inactiveGroups];
};
